import React from "react";

import Api from "../../services/Api";
import useAuth from "../../routes/login/AuthContext";

import { Grid } from "../../UI/Grid";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { COLOR_WHITE } from "../../constants/styles";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { useSnackbar } from "../../hooks/useSnackbar";
import { Network } from "../../services/NetworkApi";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";

interface IProps {
  subnetworks: Network[];
}

export const SetAllToButtons: React.FC<IProps> = (props) => {
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const [isAllowLoading, setIsAllowLoading] = React.useState(false);
  const [isNotAllowLoading, setIsNotAllowLoading] = React.useState(false);

  const handleError = () =>
    showErrorSnackbar("An error occurred. Please try again");

  const onComplete = async () => {
    await loadNetworkInfoForNetworks([selectedNetworkId]);
    showSuccessSnackbar("Saved Changes");
  };

  const allowAll = async () => {
    const body = {
      subnetworkCommands: props.subnetworks.map((l2) => ({
        l1Id: selectedNetworkId,
        l2Id: l2.l2Id,
        previouslyKnownEnabled: true,
      })),
      unitTypeCommands: [],
    };

    setIsAllowLoading(true);

    Api.setMathingRules(selectedNetworkId, body, await getAuthToken())
      .then(onComplete)
      .catch(handleError)
      .finally(() => setIsAllowLoading(false));
  };

  const notAllowAll = async () => {
    const body = {
      subnetworkCommands: props.subnetworks.map((l2) => ({
        l1Id: selectedNetworkId,
        l2Id: l2.l2Id,
        previouslyKnownEnabled: false,
      })),
      unitTypeCommands: [],
    };

    setIsNotAllowLoading(true);

    Api.setMathingRules(selectedNetworkId, body, await getAuthToken())
      .then(onComplete)
      .catch(handleError)
      .finally(() => setIsNotAllowLoading(false));
  };

  return (
    <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
      <Grid item>
        <Typography color={COLOR_WHITE}>Set All To:</Typography>
      </Grid>
      <Grid item>
        <ReadOnlyWrapper>
          <Button
            isLoading={isAllowLoading}
            isDisabled={isNotAllowLoading || isSuperAdminRead()}
            appearance="primary"
            onClick={allowAll}
          >
            Enabled
          </Button>
        </ReadOnlyWrapper>
      </Grid>
      <Grid item>
        <ReadOnlyWrapper>
          <Button
            isDisabled={isAllowLoading || isSuperAdminRead()}
            isLoading={isNotAllowLoading}
            appearance="primary"
            onClick={notAllowAll}
          >
            Disabled
          </Button>
        </ReadOnlyWrapper>
      </Grid>
    </Grid>
  );
};
